import React from 'react';

type Props = {
  className?: string;
  color?: string;
};

/**
 * @deprecated Instead, use icons from `cb-icons`.
 */
const Filter = ({ className, color = '#202125' }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      fill={color}
      fillRule="evenodd"
      d="M12.5 19h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1m3-5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1m6-10h-19a.5.5 0 0 0 0 1h19a.5.5 0 0 0 0-1M19 9.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1 0-1h13a.5.5 0 0 1 .5.5"
    />
  </svg>
);

export default Filter;
